import {mock} from './index';

export default {
  searchAlert: (): void => mock('/alert-app/alert_popups?action=alertPopupDetail'),
  ackAlert: (): void => mock('/alert-app/alert_popups?action=acknowledge')
};
